export default __webpack_public_path__ + "static/media/pictogramBeaconValuable128.c1ef105f.svg";